module.exports = __webpack_public_path__ + "img/left-align.45088cbe.svg";